/**
 * 
 * Create Form
 * 
 */

import React from 'react'
import PropTypes from 'prop-types'
import SimpleBar from "simplebar-react"
import {
    Card,
    Row,
} from "reactstrap"
import './styles.scss'
function OtpPopup() {
    return (

        <React.Fragment>
            <div className="simple-right-bar otp-popup" >
                <SimpleBar>
                    <div className="modal-header simple-modal-header">
                        <h5 className="modal-title mt-0" id="myModalLabel">
                            title
                        </h5>
                    </div>
                    <div className="modal-body simple-modal-body">
                        <Row className="simple-form-row">
                            <Card>
                                card
                            </Card>
                        </Row>
                    </div>
                </SimpleBar>
            </div>
            <div className="simple-right-bar-overlay" />
        </React.Fragment>
    )
}

OtpPopup.propTypes = {
    children: PropTypes.func
}

export default OtpPopup
